'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var initialState = null;

var AuthState = function AuthState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.AUTH_STATE_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = AuthState;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/AuthState.js
// module id = 380
// module chunks = 3 4 5